export default __webpack_public_path__ + "static/img-nhs-platelet-supply-chain--mobile-0ae0dd214edf1f0a8036a55f3282aa17.jpg";